import { Button, Switch, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useToast, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, } from "@chakra-ui/react";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


const StudentsTableIn = ({ data, search, loading, setFetchAgain }) => {


	const { isOpen, onOpen, onClose } = useDisclosure()
	const { user } = ChatState();
	const [id, setId] = useState("");
	const [studentId, setStudentId] = useState("");
	const [name, setName] = useState("");
	const [dob, setDob] = useState("");
	const [nationality, setNationality] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [levels, setLevels] = useState("");
	const [group, setGroup] = useState("");
	const [reduction, setReduction] = useState("");
	const [reso, setRes] = useState("");
	const [restPayement, setRestPayement] = useState(true);
	const [picLoading, setPicLoading] = useState(true);
	const [typcour, setTypCour] = useState("");
	const [timecour, setTimeCour] = useState("");

	const [etat, setEtat] = useState('true');
	const [dff, setDateEndFormation] = useState();

	const [fetchLevelAgain, setFetchLevelAgain] = useState(true);
	const [levelTable, setLevelTable] = useState([]);
	const [groupTable, setGroupTable] = useState([]);
	const [oldGroup, setoldGroup] = useState([]);

	useEffect(() => {
		if (user != undefined)
			getAllLevels();
	}, [fetchLevelAgain === true || user != undefined])

	async function getAllLevels() {
		try {
			setLevelTable([])

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
			};
			const { data } = await axios.get(`/api/level`, config)



			setLevelTable(data)

			setFetchLevelAgain(false)

		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}

	};

	async function getGroups(name) {
		try {
			setGroupTable([])

			setGroup('');
			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
				params: { levelname: name }
			};
			const { data } = await axios.get(`/api/group`, config)



			setGroupTable(data)
			setLevels(name)




		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}

	};




	const toast = useToast();

	const openModal = (studentinfo) => {
		setId(studentinfo ? studentinfo._id : "");
		setStudentId(studentinfo ? studentinfo.studentId : "");
		setName(studentinfo ? studentinfo.name : "");
		setNationality(studentinfo ? studentinfo.nationality : "");
		setDob(studentinfo ? new Date(studentinfo.dob).toLocaleDateString() : "");
		setRes(studentinfo ? studentinfo.reso : "");

		setPhone(studentinfo ? studentinfo.phone : "");
		setEmail(studentinfo ? studentinfo.email : "");
		setLevels(studentinfo ? studentinfo.levels : "");

		setReduction(studentinfo ? studentinfo.reduction : "");
		setRestPayement(studentinfo ? studentinfo.restPayement : "")
		getGroups(studentinfo.levels);

		setTimeCour(studentinfo ? studentinfo.timecour :"");
		setTypCour(studentinfo ? studentinfo.typcour :"");
		
		if(studentinfo.group){
			setGroup(studentinfo ? studentinfo.group : "");
			setoldGroup(studentinfo ? studentinfo.group : "");

			setEtat(studentinfo.dff === '' || studentinfo.dff === null ? 'true' : 'false');
		setDateEndFormation(studentinfo ? new Date(studentinfo.dff).toISOString().substring(0, 10) : '');
		}
		
		
		setPicLoading(false);


		onOpen()
	}

	const deleteStudent = async (name, group) => {

		setFetchAgain(false);

		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
				params: { id: name }

			};

			await axios.delete(
				'/api/student',
				config
			);
			if(group!=null)
				{
			let oper = "-";
			await axios.put(
				"/api/group/nb",
				{
					group,
					oper

				},
				config
			);}
			setFetchAgain(true);
			toast({
				title: "Supprimé avec succès",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
		}
	}



	const updateStudent = async () => {
		if (!studentId || !name || !dob || !nationality || !phone || !email || !levels || !group || !typcour || !timecour) {
			toast({
				title: "Veuillez remplir tous les champs",
				status: "warning",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setPicLoading(false);
			return;
		}
		setFetchAgain(false);

		try {

			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
			};
			await axios.put(
				"/api/student",

				{
					id,
					studentId,
					name,
					dob,
					nationality,
					phone,
					email,
					levels,
					group,
					reduction,
					reso,
					dff: etat === 'true' ? null : dff,
					typcour,
					timecour 
				},
				config
			);
			if (group !== oldGroup) {
				let oper = "+";
				await axios.put(
					"/api/group/nb",
					{
						group,
						oper

					},
					config
				);
				if(oldGroup!="")
				{
				oper = "-"
				await axios.put(
					"/api/group/nb",
					{
						group: oldGroup,
						oper

					},
					config
				);
				}
			}

			toast({
				title: "Mise à jour réussie",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});


			//  history.push("/chats");
			setFetchAgain(true);



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		}
		onClose();
	};


	return (
		<>
			{/* <Button ml={4} ref={finalRef}>
        I'll receive focus on close
    </Button> */}

			<Modal
				//initialFocusRef={initialRef}
				// finalFocusRef={finalRef}

				isOpen={isOpen}
				onClose={onClose}
				size="3xl"

			>
				<ModalOverlay />
				<ModalContent m={'auto'}  >
					<ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-graduation-cap text-3xl"></i> Etudient</ModalHeader>


					<ModalBody pb={6}>
						<div className="flex flex-wrap mt-5 justify-between">

							<div>
								<Heading as='u' size='sm' >
									Information Personel
								</Heading>
								<div className="mr-4">
									<FormControl mt={2}>
										<Input id='id' placeholder='Student Id' value={studentId}
											onChange={(e) => setStudentId(e.target.value)} />
									</FormControl>
									<FormControl mt={2}>
										<Input id='name' placeholder='Nom et Prenom' value={name}
											onChange={(e) => setName(e.target.value)} />
									</FormControl>

									<FormControl mt={4}>
										<Input placeholder='Date de naissance' id='dob' value={dob}
											onChange={(e) => setDob(e.target.value)} />
									</FormControl>

									<FormControl mt={4}>
										<Input placeholder='Nationality' id='nationality' value={nationality}
											onChange={(e) => setNationality(e.target.value)} />
									</FormControl>

									<FormControl mt={4}>

										<Input placeholder='Telephone' id='yearsOf' value={phone}
											onChange={(e) => setPhone(e.target.value)} />
									</FormControl>
									<FormControl mt={4}>

										<Input placeholder='Email' id='yearsOf' value={email}
											onChange={(e) => setEmail(e.target.value)} />
									</FormControl>

									<FormControl mt={4} w={"58"}>

										<select className="w-full border p-2" defaultValue={reso !== '' ? reso : 'def'} value={reso !== '' ? reso : 'def'} onChange={(e) => { setRes(e.target.value) }}>
											<option value="def" defaultChecked disabled>Choiser le Raison de L'étude</option>
											<option value='1'>Travailler en Allemagne</option>
											<option value='2'>Ausbildung en Allemagne</option>
											<option value='3'>Études en Allemagne</option>
											<option value='4'>Visa & séjour</option>
										</select>

									</FormControl>


								</div>

							</div>


							<div>
								<Heading as='u' size='sm'>
									Class
								</Heading>

								<FormControl mt={2}>

									<select defaultValue={levels} className="w-full border p-2" onChange={(e) => { getGroups(e.target.value) }}>
										<option value="def" defaultChecked disabled>Choiser un Niveaux</option>
										{
											levelTable.map((level) => {

												return <option value={level.levelName}>{level.levelName}</option>
											})
										}
									</select>

								</FormControl>

								<FormControl mt={4} w={"52"}>

									<select className="w-full border p-2" defaultValue={group != '' ? group : 'def'} value={group != '' ? group : 'def'} onChange={(e) => { setGroup(e.target.value) }}>
										<option value="def" defaultChecked disabled>Choiser un Group</option>
										{

											groupTable.map((groupe) => {

												return <option value={groupe.groupName}>{groupe.groupName} <span>{groupe.groupType == "Hybride" ? "( Hybride )" : ""}</span></option>
											})
										}
									</select>

								</FormControl>

								<FormControl mt={4}>
									<Input placeholder='Type de cours' id='typcour' value={typcour}
										onChange={(e) => setTypCour(e.target.value)} />
								</FormControl>

								<FormControl mt={4}>
									<Input placeholder="Temps d'étude" id='timecour' value={timecour}
										onChange={(e) => setTimeCour(e.target.value)} />
								</FormControl>
							</div>


							<div className="w-40">
								<Heading as='u' size='sm'>
									Statut
								</Heading>
								<FormControl mt={2}>
									<select onChange={(e) => { setEtat(e.target.value) }} value={etat}>
										<option value='true'>Actif</option>
										<option value='false'>Arrêté</option>
									</select>
								</FormControl>
								<FormControl mt={4} display={etat == 'true' ? 'none' : 'block'}>
									<input className="border w-40 h-10 rounded-md py-2 px-1" type="date" name="dateEndFormation" value={dff}
										onChange={(e) => setDateEndFormation(e.target.value)} />
								</FormControl>
							</div>
						</div>
					</ModalBody>

					<ModalFooter>
						<Button colorScheme='blue' mr={3}
							onClick={updateStudent}
							isLoading={picLoading}>
							Enregistrer
						</Button>
						<Button onClick={onClose}>Annuler</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<TableContainer w={"full"} className="shadow-sm border">
				<Table variant={"simple"} >

					<Thead>
						<Tr className="bg-gray-50 text-black">
							<Th w={"24"}></Th>
							<Th textAlign={"center"}>Id</Th>
							<Th textAlign={"center"}>nom et pernom</Th>
							<Th textAlign={"center"}>telephone</Th>
							<Th textAlign={"center"}>level</Th>
							<Th textAlign={"center"}>group</Th>
							<Th textAlign={"center"}>rest payement</Th>
						</Tr>
					</Thead>
					<Tbody  >

						{data?.filter((student) => {
							return search.toLowerCase() === ''
								? student
								: student.name.toLowerCase().includes(search.toLowerCase());
						}).map((student, index) => {
							if (!student.group) {
								return <Tr key={index} fontSize="sm"  >

									<Td >
										{/* <User_crud tittle='edit' studentinfo={student} setFetchAgain={setFetchAgain} /> */}
										<Button bg='gray.50' onClick={() => { openModal(student) }}> <i className="fa-regular fa-pen-to-square text-blue-400 mr-2"></i> Modifier
										</Button>

										<Button fontSize={14} ml={2} bg='gray.50' onClick={() => deleteStudent(student._id, student.group)}  ><i className="fa-solid fa-trash text-red-500"></i></Button>
									</Td>
									<Td textAlign={"center"}>{student.studentId}</Td>
									<Td textAlign={"center"}>{student.name}</Td>
									{/*  <Td>{new Date(student.dob).toLocaleDateString()}</Td> */}
									{/*  <Td>{student.nationality}</Td> */}
									<Td textAlign={"center"}>{student.phone}</Td>
									{/* textAlign={"center"} <Td>{student.email}</Td> */}
									<Td textAlign={"center"}>{student.levels}</Td>
									<Td textAlign={"center"}>{student.group}</Td>
									<Td textAlign={"center"}>{student.restPayement}</Td>


								</Tr>
							}


						}
						)}


					</Tbody>


				</Table>
				<div className="w-full  flex item-center p-6">
					{loading && <i className="fa-solid fa-circle-notch animate-spin m-auto text-xl"></i>}
					{!loading && data.length === 0 && <span className="text-md text-gray-300 m-auto">Aucun résultat.</span>}
				</div>
			</TableContainer>
		</>
	);


};

export default StudentsTableIn;
